export const SELECTED_SPRAY_EVENT_IDS_TABLE_PAGINATION_NAME =
    'selectedSprayEventIdsPage';
